export default "__VITE_PUBLIC_ASSET__b2dca2fe__"